//https://dev.to/dmtrkovalenko/the-neatest-way-to-handle-alert-dialogs-in-react-1aoe

import { CircularProgress, Dialog, DialogContent, makeStyles, ThemeProvider, Typography } from '@material-ui/core';
import React, { createContext, useCallback, useState } from 'react';

export interface ILoadingProps {
  promise?: Promise<any>;
  message?: string;
  minTimeToShow?: number;
}

// we will pass the opening dialog function directly to consumers
export const LoadingServiceContext = createContext<(promise: Promise<any>, message?: string, minTimeToShow?: number) => Promise<any>>(Promise.reject);

export const LoadingServiceProvider = ({ children, theme }) => {
  const [options, setOptions] = useState<ILoadingProps[]>([]);

  const loadPromise = useCallback((promise: Promise<any>, message?: string, minTimeToShow: number = 1000) => {
    let ref = setTimeout(() => setOptions((o) => [...o, { promise, message, minTimeToShow }]), minTimeToShow);
    return (
      promise?.finally(() => {
        clearTimeout(ref);
        setOptions((o) => {
          let newO = [...o];
          newO.splice(0, 1);
          return newO;
        });
      }) ?? Promise.reject()
    );
  }, []);

  return (
    <>
      <LoadingServiceContext.Provider value={loadPromise} children={children} />
      <LoadingDialog theme={theme} open={(options?.length ?? 0) > 0} message={options?.[0]?.message} />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  content: { display: 'flex', padding: theme.spacing(2) + 'px !important' },
  icon: { margin: 'auto' },
  message: { display: 'inline-block', boxSizing: 'border-box', margin: 'auto', paddingLeft: theme.spacing(4) },
}));

export const LoadingDialog = ({ open, message = 'Loading!', theme }) => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} transitionDuration={{ exit: 0 }}>
        <DialogContent className={classes.content}>
          <CircularProgress className={classes.icon} />
          <div className={classes.message}>
            <Typography variant='h6'>{message}</Typography>
          </div>
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};
